fx.ns("repositories", class PhotosRepository extends fx.ModelArray {

    constructor(model)
    {
        super(model);

        this._extracting = false;

        this.endpoint = "/app/photos";
    }

    get requestDefaultParams()
	{
		return {connectionid : fx.get("connectionid")};
	}

    get extracting()
    {
        return this._extracting;
    }

    set extracting(val)
    {
        this.event("photo-extracted-updated");
        
        this._extracting = val;
    }

    get count()
    {
        return this.active.length;
    }

    
    get active()
    {
        return this.filter(function(photo) { return !photo.deleted; });
    }
    
    get iaEnabled()
    {
        return this.every(function(photo){ return photo.faces != null;});
    }

    get available()
    {
        return this.filter( photo => /*!photo.isHeic &&*/ !photo.deleted );
    }

    get containHeic()
    {
        return this.filter( photo => photo.isHeic).length > 0;
    }
   

    // --------------------------------------- //
    use(id, use)
    {
        let photo = this.find({id : id});

        if (!photo)
            photo = this.find({oldid : id});
        
        if (photo) // photo can be deleted 
            photo.number = use ? (photo.number + 1) : Math.max(0, photo.number - 1);
    }

    updateUrls(bookid, accountid)
    {
        this.post(  { 
            action:"getAll", 
            bookid : bookid,
            accountid : accountid
        }, 
        this._updateUrls);
    }

    _updateUrls(data)
    {
        if (data.error)
        {
            this.event("update-url-error")
        }
        else
        {
            for (let i = 0; i < data.length; i++)
            {
                let photo = this.find({id : data[i].id});
                if (photo)
                    photo.update({
                                    thumb : Utils._fixURL(data[i].thumb),
                                    url  : Utils._fixURL(data[i].url),
                                    light_url : Utils._fixURL(data[i].light_url)
                                });
                    
            }

            this.event("update-url-complete")
        }
    }
   
});